import { DialogActions } from '@csp/csp-web-ui';
import { FC } from 'react';
import { useDownloadFile } from '../hook/useDownloadFile';
import { StaticContentService } from '../../../../common/service/StaticContentService';
import { AlertDialog } from '../../../../common/component/AlertDialog';

type Props = {
  downloadFileState: ReturnType<typeof useDownloadFile>;
};

export const DownloadFileDialog: FC<Props> = ({ downloadFileState }) => {
  const texts = StaticContentService.getGenericBlock('webHcpDocumentRepository', 'downloadFileDialog');
  const commonButtonTexts = StaticContentService.getGenericBlock('webHcpCommonUserInterface', 'commonButton');

  return downloadFileState.dialogToggle.isMounted ? (
    <AlertDialog
      error={downloadFileState.error?.message}
      header={texts.header.text}
      open={downloadFileState.dialogToggle.isOpen}
      loadingInitialText={texts.body.text}
      onClose={downloadFileState.cancelFileDownload}
      actions={
        <DialogActions
          cancelLabel={commonButtonTexts.button.cancel.label}
          onCancel={downloadFileState.cancelFileDownload}
        />
      }
      isLoadingInitial={downloadFileState.isPending}
    />
  ) : null;
};
